// extracted by mini-css-extract-plugin
export default {"container":"_3WO-wOi2","nameContainer":"_1vULpM2H","badges":"_1ucVmcxA","shared":"_35dYbI-q","displayName":"_2rLxnHS3","item":"_3DgtCzqK","rating":"_3_hqbTnU","lastSeen":"_22n46Xfq"};